import { render, staticRenderFns } from "./HazardAppearanceSettings.vue?vue&type=template&id=28b8d8dc&scoped=true"
import script from "./HazardAppearanceSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./HazardAppearanceSettings.vue?vue&type=script&setup=true&lang=js"
import style0 from "./HazardAppearanceSettings.vue?vue&type=style&index=0&id=28b8d8dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b8d8dc",
  null
  
)

export default component.exports